import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useGetUsersQuery } from '../../features/users/usersApiSlice';
import { memo } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import { useLocation, Navigate, Outlet } from "react-router-dom";
import nameStringFn from "../../data/nameStringFn";
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../Styles/TableStyles';
import { useGetdesignationsQuery } from '../../features/designations/designationApiSlice';
import DetailsIcon from '@mui/icons-material/Details';
// import UserdetailsModal from './UserdetailsModal';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useGetofficesQuery } from '../../features/offices/officesApiSlice';
import useAuth from '../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ExcelDownload from '../../data/exceldownload';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {DatePicker} from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { useGetAssetsFinalQuery } from '../../features/addassets/addassetfinalApiSlice';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Button2Div =styled.div`
  display: flex;
  justify-content: end;

`
const Wrapper = styled.div`
    display: flex;
    background-color: white;
    align-items:center;
    /* width: 100; */
`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 15;

// The user Roles Array function creates an array of all roles so that they can be displayed as chips in the table.
const userRolesArray = (userObject) => {
  if (!userObject?.roles) return [];
  
  const mainRoleArray = userObject?.roles?.main || [];
  let officeRoleArray = [];
  
  for(let key in userObject?.roles){
    if(key !== "main" && userObject?.roles[key]){
      for(let val of userObject?.roles[key]){
        if (val) officeRoleArray.push(`${val} (${key})`)
      }
    }
  }
  
  return mainRoleArray.concat(officeRoleArray);
}


//The findSubordinateOffices function gives an array of objects of all offices which are subordinate to officeName.
const findSubordinateOffices = (offices, officeName, result = []) => {
  const subOffices = offices? offices?.filter(office => office?.superioroffice === officeName):[];
  for (const subOffice of subOffices) {
    result.push(subOffice);
    findSubordinateOffices(offices, subOffice?.name, result);
  }
  return result;
}

//The filterFunctionUser gives the array of filtered array of users as per roles available.
const filterFunctionUser =  (userArray, Auth, presentOffice, officeArray ) =>{
  let tempArray = structuredClone(userArray);
  const rolesArray = Auth.roles[presentOffice];
  if(Auth.roles["main"].includes("Admin") || rolesArray.some(item => ["level1approver", "level2approver"].includes(item)) ){
    return userArray;
  }
  if(rolesArray.includes("Bo") && !rolesArray.includes("UnitHead")){
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).includes(presentOffice))
    return tempArray
  }
  if(rolesArray.includes("UnitHead")){
    const subordinateOffices = findSubordinateOffices(officeArray, presentOffice).map(x=> x.name)
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).some(item => subordinateOffices.concat(presentOffice).includes(item)));
    return tempArray
  }
}

//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [assetdetailmodalopen, setAssetDetailmodalopen] = useState(false);
  const [assetdetailModaldata, setAssetDetailModaldata] = useState({});
  const [downloadData, setDownloadData] = useState({});
  const [tempTableData, setTempTableData] = useState([]);
  const Auth = useAuth();
  const presentOffice = useSelector(state => state.office.off)


  const [searchData, setSearchData] = useState({
    name:"",
    email:"",
    designation:[],
    office:[],
    roles:[],
    purchase_date_from:null,
    purchase_date_to:null,
    warranty_date_from:null,
    warranty_date_to:null
  }); 


  const {users} =  useGetUsersQuery("UserList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })
  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  })
  const {designations} = useGetdesignationsQuery("DesigList", {
    selectFromResult: ({ data }) => ({
      designations: data?.entities
    }),
  })

  const {offices} = useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })

  const [tabledata, setTabledata]= useState([]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAssetDetailModalClose = () => {
    setAssetDetailmodalopen(false);
  };

  const handleDetailsClick = (e, row)  => {
    setAssetDetailModaldata(row);
    setAssetDetailmodalopen(true)
  };
  console.log(searchData)
  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(tempTableData);
    let tempSearchData = structuredClone(searchData);
    console.log(event)
    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
     }else if (event.$d){
      if(name === "purchase_date_from" && tempSearchData["purchase_date_to"]?.length && event.$d > new Date(tempSearchData["purchase_date_to"]) ){
          alert(`"From" Purchase Date cannot be after "To" Purchase Date`);
          return;
      }
      if(name === "purchase_date_to" && tempSearchData["purchase_date_from"]?.length && event.$d < new Date(tempSearchData["purchase_date_from"])){
        alert(`"From" Purchase Date cannot be after "To" Purchase Date`);
        return;
      }
      if(name === "warranty_date_from" && tempSearchData["warranty_date_to"]?.length && event.$d > new Date(tempSearchData["warranty_date_to"])){
        alert(`"From" Warranty Date cannot be after "To" Warranty Date`);
        return;
      }
      if(name === "warranty_date_to" && tempSearchData["warranty_date_from"]?.length && event.$d < new Date(tempSearchData["warranty_date_from"]) ){
        alert(`"From" Warranty Date cannot be after "To" Warranty Date`);
        return;
      }
      tempSearchData[name]= event.$d;
     }else{
      tempSearchData[name] = newValue;
     }
    setSearchData(tempSearchData);
     for(let key in tempSearchData){

      if( ["name","oem_tag","oem"].includes(key) && tempSearchData[key].length){
        tempData = tempData.filter(x=> x[key].toLowerCase().includes(tempSearchData[key].toLowerCase()))          
      }
      if(key === "user" && tempSearchData[key].length){
        tempData = tempData.filter(x=>`${users[x?.alloc_user]?.email} (${nameStringFn(users[x?.alloc_user])})`.toLowerCase().includes(tempSearchData[key].toLowerCase()))
      }
      if(key === "store" && tempSearchData[key].length){
        tempData = tempData.filter(x=> tempSearchData[key].includes(x["cur_store"]))          
      }
      if(key === "location" && tempSearchData[key].length){        
        tempData = tempData.filter(x=> tempSearchData[key].includes(x[key]))
      }
      if(key === "purchase_date_from" ){ 
        if(tempSearchData[key]?.toISOString()?.length) tempData = tempData.filter(x => (tempSearchData["purchase_date_from"] <= new Date(x["purchase_date"])))
        if(event?.type === "click"){
          tempSearchData["purchase_date_to"] = null;
          setSearchData(tempSearchData)
        }
      }
      if(key === "purchase_date_to" && tempSearchData[key]?.toISOString()?.length  ){
        tempData = tempData.filter(x => (tempSearchData["purchase_date_to"] >= new Date(x["purchase_date"])))
      }
      if(key === "warranty_date_from"){
        console.log(tempSearchData[key]?.toISOString()?.length)
        if(tempSearchData[key]?.toISOString()?.length) tempData = tempData.filter(x => (tempSearchData["warranty_date_from"] <= new Date(x["warrantyexp_date"])))
        if(event?.type === "click"){
          tempSearchData["warranty_date_to"] = null;
          setSearchData(tempSearchData);
        }
      }
      if(key === "warranty_date_to" && tempSearchData[key]?.toISOString()?.length  ){
        tempData = tempData.filter(x => (tempSearchData["warranty_date_to"] >= new Date(x["warrantyexp_date"])))
      }  
    }
    setTabledata(tempData.sort((a,b) => b.name - a.name));
  }

useEffect(()=>{
  if(getSingleasset && users){
    let assetArray = structuredClone(Object.values(getSingleasset));
    let finalArray = []
    for(let val of assetArray){
      val["user"] = users[val?.alloc_user]? val?.cur_loc === "user"? `${users[val?.alloc_user]?.email} (${nameStringFn(users[val?.alloc_user])})`:"Not Applicable":"User not Defined";
      val["location"] = val?.cur_loc === "store"? "Store": val?.alloc_ofc;
    }
    if(Object.values(Auth.roles).flat(3)?.includes("Admin")){
      console.log("Entered Admin")
      finalArray = structuredClone(assetArray);
      setTempTableData(finalArray)
      setTabledata(finalArray)
      return
    }    
    if(Object.values(Auth.roles).flat(3)?.includes("level1approver") || Object.values(Auth.roles).flat(3)?.includes("level2approver")){
      console.log("Entered Level1approver")
      let storeOffices = [];
      for(let key in Auth.roles){
        if (Auth.roles[key].includes("level1approver") || Auth.roles[key].includes("level2approver")){
          storeOffices.push(key);
        }
      }
      finalArray = finalArray.concat(assetArray.filter(x => storeOffices.includes(x.cur_store) || storeOffices.includes(x.pur_store)))
    }
    if(Object.values(Auth.roles).flat(3)?.includes("Bo") || Object.values(Auth.roles).flat(3)?.includes("UnitHead")){
      console.log("Entered Bo or UnitHead")
      let uhOffices = []
      for(let key in Auth.roles){
        if (Auth.roles[key].includes("Bo") || Auth.roles[key].includes("UnitHead")){
          uhOffices.push(key);
        }
      }
      //Check for duplicate object entries
      assetArray.filter(x => uhOffices.includes(x.alloc_ofc)).forEach(obj => {
        //Check if the object exists in the array
        if(!finalArray.some(item => item._id === obj._id)){
          finalArray.push(obj);
        }
      }
      )
    }
    //Checking for duplicate Object Entries
    assetArray.filter(x => Object.values(Auth.id) === x?.alloc_user).forEach(obj => {
    //Check if the object exists in the array
    if(!finalArray.some(item => item._id === obj._id)){
          finalArray.push(obj);
        }
      }
    )
    setTempTableData(finalArray)
    setTabledata(finalArray)
  }
},[getSingleasset,users])
console.log(Auth)
//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["category","name", "oem_tag","oem", "user","specification","pur_store","in_transit", "cur_store","location", "purchase_date", "installation_date", "warrantyexp_date", "unit_price", "last_trans_date"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["specification"]:Object.entries(val.specification).map(x=> ` ${x[0]}: ${x[1]}`).join(","), ["last_trans_date"]:moment(val.last_trans_date).format("DD/MM/YYYY")}
      finalDownloadData.push(others)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])
   
  return (
    <>    
      <HeadingWrap>
        <Span>My Notifications</Span>
      </HeadingWrap>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"assetDetail"} sheetName={"sheet1"}/>
      </Button2Div> 
      <div>
      <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
      <TableHead  style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow >
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"3%"}}} >Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}} align="left">Asset</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"10%"}}}align="left">OEM Tag</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"11%"}}} align="left">OEM/Brand</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"12%"}}} align="left">User</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"11%"}}} align="left">Store</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"13%"}}} align="left">Location</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Purchase Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Warranty Date</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"13%"}}} align="left">Detail</TableCell>

        </TableRow>

        <TableRow  >
          <TableCell>
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='name' onChange={handleSearchChange} label="Search Asset" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='oem_tag' onChange={handleSearchChange} label="Search OEM Tag" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='oem' onChange={handleSearchChange} label="user" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='user' onChange={handleSearchChange} label="user" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>

          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "store")}
              size="small"
              value={searchData?.store}
              //We set the options for available Store offices sorted by level and duplicacy removed.
              options={(getSingleasset)? Object.values(getSingleasset)?.map(x => x?.cur_store)?.flat(3)?.filter((item, index) => Object.values(getSingleasset)?.map(x => x?.cur_store)?.flat(3)?.indexOf(item) === index).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Store "  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>

          <TableCell>

          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "location")}
              size="small"
              value={searchData?.location}
              //We set the options for available offices sorted by level and duplicacy removed.
              options={(getSingleasset)? Object.values(getSingleasset)?.map(x => x.alloc_ofc)?.flat(3)?.filter((item, index) => Object.values(getSingleasset)?.map(x => x.alloc_ofc)?.flat(3)?.indexOf(item) === index).filter(x => x!== "").concat("Store").sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Location "  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>

          <TableCell>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} sx={{margin:"0px", display:"flex"}} >
              <Wrapper>
              <DatePicker
                label="From"
                maxDate={searchData?.purchase_date_to?.toISOString().length? dayjs(searchData?.purchase_date_to):null}
                slotProps={{ textField: { size: 'small', fullWidth:"200%" } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.purchase_date_from?.toISOString().length? dayjs(searchData?.purchase_date_from):null}
                format="DD/MM/YYYY"
                // required={finalSubClicked}               
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'purchase_date_from')}
              />
              {searchData?.purchase_date_from?.toISOString()?.length &&  <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'purchase_date_from')} />}
              </Wrapper>
            </DemoContainer>
          </LocalizationProvider>
          {searchData?.purchase_date_from?.toISOString()?.length && <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} >
            <Wrapper>
              <DatePicker
                label="To"
                minDate={searchData?.purchase_date_from?.toISOString()?.length? dayjs(searchData?.purchase_date_from):null}
                slotProps={{ textField: { size: 'small' } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.purchase_date_to?.toISOString().length? dayjs(searchData?.purchase_date_to):null}
                format="DD/MM/YYYY"
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'purchase_date_to')}
              />
            {searchData?.purchase_date_to?.toISOString().length && <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'purchase_date_to')} />}
            </Wrapper>
            </DemoContainer>
          </LocalizationProvider>}        
          </TableCell>          
          <TableCell>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} >
            <Wrapper>
              <DatePicker
                label="From"
                maxDate={searchData?.warranty_date_to?.toISOString()?.length? dayjs(searchData?.warranty_date_to):null}
                slotProps={{ textField: { size: 'small' } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.warranty_date_from?.toISOString().length? dayjs(searchData?.warranty_date_from):null}
                format="DD/MM/YYYY"
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'warranty_date_from')}
              />
            {searchData?.warranty_date_from?.toISOString()?.length && <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'warranty_date_from')} />}
            </Wrapper>
            </DemoContainer>


          </LocalizationProvider>
          {  searchData?.warranty_date_from?.toISOString()?.length &&          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker', 'DatePicker']} >
            <Wrapper>
              <DatePicker
                label="To"
                minDate={searchData?.warranty_date_from?.toISOString()?.length? dayjs(searchData?.warranty_date_from):null}
                slotProps={{ textField: { size: 'small' } }}
                sx={{backgroundColor:"white"}}
                value={searchData?.warranty_date_to?.toISOString()?.length? dayjs(searchData?.warranty_date_to):null}
                format="DD/MM/YYYY"
                onChange={(event, newValue) => handleSearchChange(event, newValue, 'warranty_date_to')}
              />
            {searchData?.warranty_date_to?.toISOString()?.length && <ClearIcon onClick = {(event, newValue)=>handleSearchChange(event, newValue, 'warranty_date_to')} />}
            </Wrapper>
            </DemoContainer>
          </LocalizationProvider>
          
          }
          </TableCell>
          <TableCell>
          </TableCell>
        </TableRow>
      </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : tabledata
          ).map((row,index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row" align='center' sx={{ fontSize: tableFontSize}}>
              {(page)*(rowsPerPage)+index+1}
              </TableCell>


              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.name}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.oem_tag}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.oem}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.user}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.cur_store}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row?.location}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {moment(row?.purchase_date).format("DD-MM-YYYY")}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {moment(row?.warrantyexp_date).format("DD-MM-YYYY")}
              </TableCell>

              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                <DetailsIcon sx={{color:"green", fontSize:"40px", '&:hover':{"cursor":"pointer"}}} onClick={(e) => handleDetailsClick(e, row)} />
              </TableCell>              

            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata? tabledata?.length:[]}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </div>    

    </>
  );
}